export const ACCOUNT_GROUP_REASONS = [
  { value: 'same_legal_entity', label: 'Same legal entity' },
  { value: 'same_owner', label: 'Same owner' },
  { value: 'franchise_or_chain', label: 'Franchise or chain' },
  { value: 'other', label: 'Other' },
] as const

export type AccountGroupReason = (typeof ACCOUNT_GROUP_REASONS)[number]['value']

export interface AccountGroupMemberRow {
  id: string
  dba_name: string
  status: string
  fiserv_mid: string | null
}

export interface AccountGroupStatusCounts {
  active: number
  suspended: number
  terminated: number
}

export interface AccountGroupRecord {
  id: string
  name: string
  note?: string | null
  reason_type: AccountGroupReason | string
  status_counts: AccountGroupStatusCounts
  members: AccountGroupMemberRow[]
  monthly_volume_total?: string
  ytd_volume_total?: string
  created_at?: string
  updated_at?: string
}

export interface RelatedAccountGroup {
  id: string
  name: string
  note?: string | null
  reason_type: string
  related_accounts: AccountGroupMemberRow[]
}

export function accountGroupReasonLabel(value: string): string {
  return ACCOUNT_GROUP_REASONS.find((reason) => reason.value === value)?.label ?? value
}
